import React from 'react';

const SbBetsSumPercentPerPlayer = () => {
    return (
        <div>

        </div>
    )
}

export default SbBetsSumPercentPerPlayer;